import { ICustomRequirements } from './models'

export const HEADQUARTERS_ONLY_FLAGS: Record<string, ICustomRequirements> = {
  OSS: {
    defaultMessage: 'Only applicable for Headquarters',
    noRequiredFlagsMessage:
      'Partner don’t have CBN/ CRS ID/ Ms4 ID it is not eligible for OSS access',
    requiredFlags: ['cbn', 'crs', 'ms4'],
  },
}
